export default __webpack_public_path__ + "static/media/carousel10.14272ae0.jpg";